import { useState, useEffect } from "react";
import EventService from "../../../services/event_service";

/**
 * Hook dedicado a gerenciar os Eventos de Avaliação e Teste (Ciclos Abertos).
 */
export const useEvaluationEvents = ({ idTenant, withLoading }) => {
    const [activeEvent, setActiveEvent] = useState(null);
    const [activeTestEvent, setActiveTestEvent] = useState(null);

    useEffect(() => {
        if (!idTenant) return;

        const checkEvents = async () => {
            try {
                await withLoading('checkEvent', async () => {
                    const allEvents = await EventService.getAll(idTenant);
                    const now = new Date();

                    const findActiveEvent = (type) => {
                        return allEvents.find(evt => {
                            if (evt.type !== type) return false;
                            if (evt.status === 'inactive' || evt.status === 'closed') return false;
                            
                            const startDate = evt.startDate ? new Date(evt.startDate) : null;
                            const endDate = evt.endDate ? new Date(evt.endDate) : null;
                            
                            if (startDate && now < startDate) return false;
                            if (endDate) {
                                const endOfDay = new Date(endDate);
                                endOfDay.setHours(23, 59, 59, 999);
                                if (now > endOfDay) return false;
                            }
                            return true;
                        }) || null;
                    };

                    setActiveEvent(findActiveEvent('evaluation'));
                    setActiveTestEvent(findActiveEvent('test'));
                });
            } catch (e) {
                console.error("Erro ao verificar evento ativo", e);
            }
        };
        checkEvents();
    }, [idTenant, withLoading]);

    return { activeEvent, activeTestEvent };
};
